import { Grid2 as Grid } from "@mui/material"
import Button from "@mui/material/Button"
import { Field, Formik } from "formik"
import { useMemo } from "react"
import * as yup from "yup"
import { Ente } from "../../types"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogProps } from "../DialogForm"
import { FormikTextField } from "./formsHelpers"
import { useTranslation } from "react-i18next"
import useUserCanWriteAndDelete from "../../hooks/permissions"

export default function EnteForm({ item, save, ref }: FormInDialogProps<Ente>) {
  const { t } = useTranslation()
  const initialValues = useMemo(() => {
    return (
      item ?? {
        nome: "",
      }
    )
  }, [item])

  const schema = useMemo(
    () =>
      yup.object().shape({
        nome: yup.string().required().label(t("donatore.nome")),
      }),
    [t]
  )

  const userCanWriteAndDelete = useUserCanWriteAndDelete()

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as Ente).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="nome"
                  label={t("ente.nome")}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>
              <Grid size={12}>
                <Field
                  component={FormikTextField}
                  name="note"
                  label={t("ente.note")}
                  multiline
                  minRows={6}
                  required
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  slotProps={{
                    input: {
                      readOnly: userCanWriteAndDelete ? false : true,
                    },
                  }}
                />
              </Grid>
            </Grid>

            <Button ref={ref} type="submit" color="primary" sx={{ display: "none" }}></Button>
          </form>
        )
      }}
    </Formik>
  )
}
